const CLIENTS = [
  { name: "Swan River Seafood", type: "Restaurant" },
  { name: "Southwest Woodworks", type: "Custom Woodworking" },
  { name: "Costco", type: "Retail" },
  { name: "FedEx", type: "Logistics" },
];

export default function TrustedBy() {
  return (
    <section data-testid="trusted-by-section" className="py-16 md:py-20 border-y border-white/5" aria-label="Trusted By">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <p className="text-xs font-bold tracking-[0.2em] uppercase text-slate-500 text-center mb-10">
          Trusted By Local & National Brands
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {CLIENTS.map((client) => (
            <div
              key={client.name}
              data-testid={`client-${client.name.toLowerCase().replace(/\s/g, "-")}`}
              className="glass-card glass-card-hover flex flex-col items-center justify-center py-8 px-4 text-center"
            >
              <span
                className="text-lg md:text-xl font-semibold text-white mb-1"
                style={{ fontFamily: 'Outfit, sans-serif' }}
              >
                {client.name}
              </span>
              <span className="text-xs text-slate-500">{client.type}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
